import { PageModule } from 'app/pages/types';
import React from 'react';
import Survey from './Survey';

export const SurveyPageModule: PageModule = {
  pageIf: (page, exception) => !exception && page === 'index',
  render: () => <Survey />
};
